import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  ShowSP = false;

  constructor(
    private router: Router,
  ) {}

  ngOnInit() {
    // if (this.router.url == '/' || this.router.url.indexOf('/business') === 0) {
      this.ShowSP = true;
    // }
  }

  scrollToPageTop(event: Event) {
    event.preventDefault();
    window.scrollTo(0, 0);
  }
}
